module.exports = __webpack_public_path__ + "img/holiday.2729b7d.png";